import { Link } from "@tanstack/react-router"
import Logo from "~/assets/images/logo.svg";
import Tiktok from "~/assets/icons/tiktok.svg";
import X from "~/assets/icons/x.svg";
import Instagram from "~/assets/icons/instagram.svg";
import Facebook from "~/assets/icons/facebook.svg";

export function Footer() {
  return (
    <footer className="bg-[#121315] px-[16px] pb-[40px] pt-[100px] text-[#F0F5F4] sm:px-[6%] sm:py-[5%] md:px-[10%] md:py-[5%]">
      <div className="flex flex-col flex-wrap justify-between gap-8 sm:flex-row sm:gap-10">
        <div className="w-full sm:w-6/12">
          <div className="mb-4">
            <img src={Logo} alt="" className="w-32 sm:w-auto" />
          </div>
          <div className="mb-6 sm:mb-10">
            <p className="text-base sm:w-[70%] sm:text-xl">
            Schedule your first consultation and take the next step towards a healthier you.
            </p>
          </div>
        </div>
        <div className="flex gap-10 sm:w-4/12 sm:gap-8">
          <div className="flex w-full items-center gap-4 sm:justify-end sm:gap-6">
            <a href="http://tiktok.com/@proxymedicine" target="_blank" className="text-2xl sm:text-[34px]" rel="noreferrer">
              <img
                src={Tiktok}
                alt=""
                className="w-32 sm:w-auto"
              />
            </a>
            <a
              href="https://www.instagram.com/proxymedicine?igsh=MnlsajcwaTBrbW9q"
              target="_blank"
              className="text-xl sm:text-2xl" rel="noreferrer"
            >
              <img
                src={Instagram}
                alt=""
                className="w-32 sm:w-auto"
              />
            </a>
            <a
              href="https://x.com/ProxyMed_?s=09"
              target="_blank"
              className="text-xl sm:text-2xl" rel="noreferrer"
            >
              <img
                src={X}
                alt=""
                className="w-32 sm:w-auto"
              />
            </a>
            <a href="https://www.facebook.com/share/18hR8tedoR/" target="_blank" className="text-xl sm:text-2xl" rel="noreferrer">
              <img
                src={Facebook}
                alt=""
                className="w-32 sm:w-auto"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="mt-[8%] flex flex-col justify-between gap-4 text-base sm:mt-[10%] sm:flex-row sm:gap-5 sm:text-xl">
        <p className="sm:text-left sm:text-sm">
          © 2024 Proxymedicine inc. All rights reserved.
        </p>
        <p className="sm:text-right sm:text-sm">
            <Link to="/privacy-policy" className="underline">Privacy Policy</Link> |{" "}
            <Link to="/terms" className="underline">Terms & Conditions</Link>
        </p>
      </div>
    </footer>
  );
}
